<template>
    <div    class="tooltip-container">
        <!-- Html always shown and what the user hovers over in order to show tooltip. -->
        <slot></slot>

        <!-- The actual tooltip, that is being displayed -->
        <span :style="{width: width + 'px', 'margin-left': (-1 * width / 2) + 'px'}"  class="tooltip-text">
            <slot   name="tooltip-text">{{ tooltipText }}</slot>
        </span>
    </div>
</template>

<script>

import axios from "axios"
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';

export default {
    name: "TooltipContainer",
    mixins: [SonicuCoreMixin, iconNamesMixin],
    components: {},
    props: {
        tooltipText: {
            type: String,
            default: '',
        },
        width: {
            type: Number,
            default: 120,
        },
    },
    data() {
        return {

        }
    },
    created() {

    },
    mounted() {

    },
    methods: {

    },
    computed: {

    },
    watch: {

    },
}
</script>

<style scoped>
    .tooltip-container {
        position: relative;
        display: inline-block;
    }
    .tooltip-container .tooltip-text {
        visibility: hidden;
        background-color: #555;
        color: #fff;
        text-align: center;
        border-radius: 6px;
        padding: 5px 0;
        position: absolute;
        z-index: 1;
        bottom: 125%;
        left: 50%;
        opacity: 0;
        transition: opacity 0.3s;
    }

    .tooltip-container .tooltip-text::after {
        content: "";
        position: absolute;
        top: 100%;
        left: 50%;
        margin-left: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: #555 transparent transparent transparent;
    }

    .tooltip-container:hover .tooltip-text {
        visibility: visible;
        opacity: 1;
    }

</style>